<template>
  <div class="card-refund">
    <div class="item-refund-wrapper" v-for="(refund, index) in refundList" :data="refund" :key="`refund_card${index}`">
      <div class="item-refund">
        <div>
          <label class="f-13 f-c-black f-regular m-d-0">{{ refund.title }}</label>
        </div>
        <div>
          <label class="f-13 f-c-black f-regular m-d-0">{{ refundTotal(refund) }}</label>
        </div>
        <div>
          <label class="f-13 f-c-midgrey f-regular m-d-0">{{ refund.subtitle }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jenisBayar } from "@/store/utils/vars";

export default {
  name: "SOCardRefund",
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    refundList() {
      return this.dataList;
    },
  },
  methods: {
    refundTotal(refund) {
      let jenis_bayar = jenisBayar.find((j) => j.code === refund.jenis_bayar);

      if (jenis_bayar.type === "piece") {
        return `${refund.total} ${refund.satuan}`;
      } else {
        return this.$options.filters.currency(refund.total);
      }
    },
  },
};
</script>

<style scoped>
.card-refund {
  border: 1px solid #c8d0dd;
  border-radius: 0.25rem;
  box-shadow: inset 0px -1px 0px #c8d0dd;
  margin-bottom: 8px;
}

.item-refund-wrapper {
  border-bottom: 1px solid #ededed;
}

.card-refund div.item-refund-wrapper:nth-last-child(1) {
  border-bottom: none;
}

.card-refund div.item-refund {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 10px 18px;
}

.card-refund div.item-refund div:nth-child(3) {
  grid-column: span 2 / span 2;
}

.card-refund div.item-refund div:nth-child(2) {
  justify-self: end;
}
</style>
